import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";

const AdminApiService = new AdminApi()

export default {
    data() {
        return {
            filter: '',
            onlyActives: true,
            openAddVersion: false,
            drivers: [],
            types: [],
            versions: []
            // pagination: {
            //     page: 1,
            //     limit: 100,
            //     totalCount: 0
            // }
        }
    },
    computed: {
        filteredUsers() {
            return this.versions.filter(item => {
                return item.system.toLowerCase().indexOf(this.filter.toLowerCase()) > -1;

            }).sort((a,b) => this.compareNewes(a,b))
        }
    },
    methods: {
        getVersions: getVersions,
        deleteVersion: deleteVersion,
        keymonitor: keymonitor,
        openAddVersionModal: openAddVersionModal,
        compareNewes(a, b) {
            let aTime = a.timestamp;
            let bTime = b.timestamp;
            if (aTime > bTime)
                return -1;
            if (aTime < bTime)
                return 1;
            return 0;
        },

    },
    created(){
        let _self = this;
        this.$topnavbar.$on('closeAddVersion', () => {
            _self.openAddVersion = false;
        });
        this.$topnavbar.$on('successAddVersion', () => {
            _self.openAddVersion = false;
            swal('Uspešno', 'Uspešno dodata verzija', 'success')
            _self.getVersions();
        });

    },

    beforeMount() {
        if (session.getRole() !== 'ADMIN') {
            this.$router.push('/login');
            return;
        }
        this.getVersions()
    },
    watch: {
        'filter': function (newVal) {
            if (newVal.length === 0){
                // this.pagination.page = 1;
                // this.getDrivers();
            }
        },

    }
}

function getVersions() {
    var _self = this;
    AdminApiService.getVersions()
        .then((response) => {
            _self.versions = response.data;
        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function openAddVersionModal() {
    this.openAddVersion = true;
}


function keymonitor(event) {

}

function deleteVersion(item) {
    var _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite da obrisete verziju ->  " + item.system + " "+ item.version +"?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        _self.$topnavbar.$emit('load');
        AdminApiService.deleteVersion(item.id)
            .then((response) => {
                swal('Uspešno', 'Uspešno ste obrisali verziju', 'success')
                _self.getVersions();
            })
            .catch((error) => {
                swal('Greška', error.message, 'error')
            })
    });

}







// WEBPACK FOOTER //
// ./src/components/MobileVersion/ChangeMobileVersion.js